<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.5004 12.625C13.2263 12.625 14.6254 11.2259 14.6254 9.5C14.6254 7.77411 13.2263 6.375 11.5004 6.375C9.77448 6.375 8.37537 7.77411 8.37537 9.5C8.37537 11.2259 9.77448 12.625 11.5004 12.625Z"
                :fill="color" 
            />
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.378919 8.92364C1.92814 4.26637 6.32111 0.90625 11.5009 0.90625C16.6783 0.90625 21.0696 4.26324 22.6207 8.91714C22.7461 9.29325 22.7462 9.70018 22.6211 10.0764C21.0718 14.7336 16.6789 18.0938 11.4991 18.0938C6.32169 18.0938 1.9304 14.7368 0.379261 10.0829C0.253905 9.70676 0.253785 9.29982 0.378919 8.92364ZM16.9691 9.5C16.9691 12.5203 14.5207 14.9688 11.5004 14.9688C8.48006 14.9688 6.03162 12.5203 6.03162 9.5C6.03162 6.47969 8.48006 4.03125 11.5004 4.03125C14.5207 4.03125 16.9691 6.47969 16.9691 9.5Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgEye',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>